import React from 'react';
import { CircularProgress, Stack, Box } from '@mui/material';
import Typography from '@mui/material/Typography';

export default function SubTitle({ club }) 
{  
  if (!club)
  {
    return(

      <CircularProgress />
    );
  }
  else
  {
    return(                    
      <Box sx={{ marginBottom:"20px" }}>
        <Stack direction="column" alignItems="center"  spacing="2" >                     
          <Typography variant="h3">{club.name}</Typography>    
          {
            club.is_local 
            ? <Typography variant="h5">Ihr bucht mit Heimvorteil!</Typography>
            : <Typography variant="h5">Willkommen in Hanau!</Typography>
          }
        </Stack>          
      </Box>                
    );
  }    
}